




import React, { useEffect } from 'react';

const InstagramWidget = () => {
  console.log("print here in initial");
  useEffect( () => {
    console.log("print in useffect inside");
    // Check if widget already initialized
    const initWidget = () => {
      if (window.lightwidget && typeof window.lightwidget.init === 'function') {
        window.lightwidget.init();
      }
    };

    // Check if script already exists
    if (!document.querySelector('script[src="https://cdn.lightwidget.com/widgets/lightwidget.js"]')) {
      const script = document.createElement('script');
      script.src = "https://cdn.lightwidget.com/widgets/lightwidget.js";
      script.async = true;
      script.onload = () => {
        initWidget();
      };
      document.body.appendChild(script);
    } else {
      initWidget();
    }

    return () => {
      // Cleanup if needed
    };
  }, []);

  return (
    <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
      <iframe
        src="//lightwidget.com/widgets/89a1c708d3fc530484be7b5760eab723.html"
        scrolling="no"
        allowtransparency="true"  // ✅ ONLY CHANGE: lowercase 't' instead of capital 'T'
        className="lightwidget-widget"
        title="Instagram Feed"
        style={{
          width: '100%',
          border: 0,
          overflow: 'hidden',
        }}
      />
    </div>
  );
};

export default InstagramWidget;